import React from 'react';
import PropTypes from 'prop-types';
import { Spinner, SmallSpinner } from '../decorators/spinner';
import classNames from 'classnames';


export class CTAButton extends React.Component {
  componentWillMount () {
    if (!this.props.onClickAction) {
      throw new Error('onClickAction must be present');
    }
  }

  renderSpinner () {
    const textOpacityVal = this.props.spinning ? 0 : 1;
    if (this.props.spinnerColor) {
      return (
        [
          <span style={{ opacity: textOpacityVal }}>{this.props.buttonText}</span>,
          <SmallSpinner show color={this.props.spinnerColor} />
        ]
      );
    }
    return (
      <Spinner />
    );
  }

  render () {
    return (
      <button
        id={this.props.id}
        disabled={this.props.isDisabled ? 'disabled' : ''}
        onClick={this.props.onClickAction}
        className={classNames('position-relative', this.props.classNameString)}
        style={ this.props.style || {} }
        {...this.props.attributes}
      >
        {this.props.spinning ? this.renderSpinner() : this.props.buttonText}
      </button>
    );
  }
}

CTAButton.defaultProps = {
  classNameString: 'btn btn-lg btn-primary form',
  isDisabled: true,
  spinning: false,
  buttonText: 'Submit'
};

CTAButton.propTypes = {
  id: PropTypes.string,
  onClickAction: PropTypes.func.isRequired,
  buttonText: PropTypes.oneOfType([
    PropTypes.object,
    PropTypes.string
  ]),
  classNameString: PropTypes.string,
  spinnerColor: PropTypes.string,
  spinning: PropTypes.bool,
  isDisabled: PropTypes.bool,
  style: PropTypes.object,
  attributes: PropTypes.object
};
